<template>
  <transition name="fade">
    <div class="filter-mask" @click="maskClick">
      <ul
        v-if="class2List.length"
        ref="popClass2ListWraper"
        class="class2-list"
      >
        <li
          v-for="(item, index) in class2List"
          :key="index"
          :class="class2Index === index ? 'pop-class2-li-active active' : ''"
          @click.prevent.stop="selectClass2List(item, index)"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
  </transition>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
  data() {
    return {}
  },
  computed: {
    ...mapState('pop', {
      class2List: state => state.class2List,
      class2Index: state => state.class2Index,
      queryData: state => state.queryData
    })
  },
  mounted() {
    this.$nextTick(() => {
      if (
        this.$refs.popClass2ListWraper &&
        document.getElementsByClassName('pop-class2-li-active')[0]
      ) {
        this.$refs.popClass2ListWraper.scrollTop = document.getElementsByClassName(
          'pop-class2-li-active'
        )[0].offsetTop
      }
    })
  },
  methods: {
    ...mapActions('pop', [
      'class1ListClick',
      'class2ListClick',
      'setActQueryData',
      'getActivitySkuList',
      'clearQueryData',
      'setFilterSort',
      'setKeyWord',
      'setSallClass1Id',
      'clearClass2Index'
    ]),
    maskClick() {
      this.closeMask()
    },
    selectClass2List(item, index) {
      this.closeMask()
      this.clearQueryData()
      this.setQueryData('saleC1Id', item.parent_id)
      this.setKeyWord('')
      this.setFilterSort(false)
      this.$emit('update:allDefalut', false)
      this.$emit('update:priceSort', false)
      this.$emit('update:decrement', true)
      this.$emit('update:increment', true)
      this.$emit('update:allSort', true)
      this.$emit('update:allUp', false)
      this.$emit('update:allDown', true)
      this.class2ListClick({ item, index })
      this.setQueryData('saleC2Id', item.id)
      this.setQueryData('page', 1)
      this.getActivitySkuList(this.queryData)
    },
    closeMask() {
      this.$emit('update:isShowMask', false)
    },
    setQueryData(name, data) {
      const queryObj = {}
      queryObj[name] = data
      this.setActQueryData(queryObj)
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-mask {
  position: absolute;
  top: 0.98rem;
  z-index: 18;

  width: 100%;
  height: 100%;
  &:before {
    display: block;

    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;

    background-color: rgba(0, 0, 0, 0.7);

    content: '';
  }
  .class2-list {
    display: flex;

    position: relative;
    z-index: 9;

    max-height: 3.52rem;
    padding: 0.36rem 0.28rem 0.36rem 0.28rem;
    overflow-x: hidden;
    overflow-y: scroll;

    background-color: #fff;

    flex-wrap: wrap;
    -webkit-overflow-scrolling: touch;

    box-sizing: border-box;

    li {
      width: 1.6rem;
      height: 0.52rem;
      margin-bottom: 0.24rem;
      overflow: hidden;

      border-radius: 0.52rem;
      border: 0.5px solid #ccc;

      font-size: 0.24rem;
      line-height: 0.52rem;
      text-align: center;
      white-space: nowrap;
      color: #666;

      text-overflow: ellipsis;
      word-break: break-all;

      box-sizing: border-box;

      &:nth-child(3n + 2) {
        margin: 0 0.24rem;
      }
      &.pop-class2-li-active {
        border: 0.5px solid #0daf52;

        font-weight: 600;
        color: #0daf52;
      }
    }
  }
}
</style>
